export default __webpack_public_path__ + "static/media/31.e44384b4.png";